import LogoOntrajectory from "../../../image/ot_logo_light.svg";
import LevelNavBarMask from "../../level/images/navbar_mask.png";

export default {
  logo_src: LogoOntrajectory,
  sidebar_background: `url(${LevelNavBarMask}) #2C4F71 right`,
  tenant_color_primary: "#88D2DC",
};
